
import makerjs from "makerjs";
function A07(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    W = Param[0].param,H = Param[1].param, W1 = Param[2].param,W2 = Param[3].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       h = H * 1 * myZoom,
       w1 = W1 * 1 * myZoom,
       w2 = W2 * 1 * myZoom,
       w = W * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       x0 = 0, x1 = 0+w1, x2 = w-w2, x3 = w, y0 = 0, y1 = h, y2 = h, y3 = 0,glassH = h, glassW = w;

   if (h !== 0) {
       var TxtH = H;
   } if (w1 !== 0) {
    var TxtW1 = W1;
} if (w2 !== 0) {
  var TxtW2 = W2;
}
   if (w !== 0) {
       var TxtW = W;
   }



   var drawAbnormalShapeA07 = {
       paths: {
           "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
           "TopLine": new makerjs.paths.Line([x1, y1], [x2, y2]),
           "RightLine": new makerjs.paths.Line([x2, y2], [x3, y3]),
           "BottomLine": new makerjs.paths.Line([x3, y3], [x0, y0]),
       }
   };
   var drawAbnormalShapeA07MarkH = {
       paths: {
           "RightLine": new makerjs.paths.Line([x3, y3], [x3, y2]),
           "RightShortUpline": new makerjs.paths.Line([x2, y2], [x3+ 2 * markShift, y2]),
           "RightShortDnline": new makerjs.paths.Line([x3, y3], [x3+ 2 * markShift, y3]),
       }
   };
   var drawAbnormalShapeA07MarkW1 = {
       paths: {
           "LeftLine": new makerjs.paths.Line([x0, y1], [x1, y1]),
           "LeftShortline": new makerjs.paths.Line([x0, y1-markShift], [x0, y1+markShift]),
           "RightShortline": new makerjs.paths.Line([x1, y1-markShift], [x1, y1+markShift]),
       }
   };
   var drawAbnormalShapeA07MarkW2 = {
       paths: {
          //  "LeftLine": new makerjs.paths.Line([x2, y2+markShift], [x3, y2+markShift]),
           "LeftShortline": new makerjs.paths.Line([x2, y2-markShift], [x2, y2+markShift]),
           "RightShortline": new makerjs.paths.Line([x3, y2-markShift], [x3, y2+markShift]),
       }
   };
   var drawAbnormalShapeA07MarkW = {
       paths: {
           "BottomLine": new makerjs.paths.Line([x0, y0 - markShift], [x3, y3 - markShift]),
           "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
           "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 - 2 * markShift]),
       }
  //  };
  
   };
   makerjs.model.addCaption(drawAbnormalShapeA07MarkW, TxtW, [x0, y0 - 2 * markShift], [x3, y3 - 2 * markShift]);//长度文字  
   makerjs.model.addCaption(drawAbnormalShapeA07MarkH, TxtH, [x3 + markShift, y2], [x3 + markShift, y3]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeA07MarkW2, TxtW2, [x2, y2- markShift], [x3, y2- markShift]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeA07MarkW1, TxtW1, [x0, y1- markShift], [x1, y1- markShift]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeA07: drawAbnormalShapeA07,
      }
    };
    markers={
      models: {
        drawAbnormalShapeA07: drawAbnormalShapeA07,
        drawAbnormalShapeA07MarkW1: drawAbnormalShapeA07MarkW1,
        drawAbnormalShapeA07MarkW2: drawAbnormalShapeA07MarkW2,
        drawAbnormalShapeA07MarkH:drawAbnormalShapeA07MarkH,
        drawAbnormalShapeA07MarkW:drawAbnormalShapeA07MarkW
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default A07;